import React, { useState } from "react";
import styled from "@emotion/styled";
import { logout, reset } from "../../features/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { theme } from "../../utils/theme";
import Button from "../Button/Button";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Wrapper = styled("div")`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
`;

const MainHeader = styled.div`
  display: flex;
  width: 70%;
  margin: auto;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 991px) {
    display: none;
  }

  .logo a {
    color: ${theme.colors.white};
  }
`;

const UnorderedList = styled.ul`
  list-style: none;
  display: flex;
  gap: 3rem;
  align-items: center;

  li a {
    color: ${theme.colors.white};
  }
`;

const MobileHeader = styled("div")`
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;

  .logo a {
    color: ${theme.colors.white};
  }

  @media (min-width: 1280px) {
    display: none;
  }
`;

const MobileHeaderNav = styled("div")`
  .mobilenav {
    display: block;
  }

  .hide {
    display: none;
  }

  @media (min-width: 1280px) {
    display: none;
  }
`;

const Header = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  const onLogout = () => {
    console.log("test");
    dispatch(logout());
    dispatch(reset());
    navigate("/login");
  };

  return (
    <Wrapper>
      <MobileHeaderNav
        className={click ? "mobileHeaderNav" : "hide"}
        // ref={innerRef}
      >
        <ul>
          {user ? (
            <>
              <li>
                <span>Hello, {user.name}</span>
              </li>
              <li>
                <Link to={`/mail`}>Send Email</Link>
              </li>
              <li>
                <Button onClickHandle={onLogout} value="Logout" />
              </li>
            </>
          ) : (
            <>
              <li>
                <Link to={`/`}>Home</Link>
              </li>
              <li>
                <Link to={`/login`}>Login</Link>
              </li>
              <li>
                <Link to={`/register`}>Register</Link>
              </li>
            </>
          )}
        </ul>
      </MobileHeaderNav>

      <MainHeader>
        <div className="logo">
          <Link to={`/`}>EmailTool</Link>
        </div>
        <UnorderedList>
          {user ? (
            <>
              <li>
                <span>Hello, {user.name}</span>
              </li>
              <li>
                <Link to={`/mail`}>Send Email</Link>
              </li>
              <Button className="btn" onClickHandle={onLogout} value="Logout" />
            </>
          ) : (
            <>
              <li>
                <Link to={`/`}>Home</Link>
              </li>
              <li>
                <Link to={`/login`}>Login</Link>
              </li>
              <li>
                <Link to={`/register`}>Register</Link>
              </li>
            </>
          )}
        </UnorderedList>
      </MainHeader>
      <MobileHeader>
        <div className="logo">
          <Link to={`/`}>EmailTool</Link>
        </div>
        <div className="mobileNav" onClick={handleClick}>
          {click ? (
            <FontAwesomeIcon icon={faTimes} />
          ) : (
            <FontAwesomeIcon icon={faBars} />
          )}
        </div>
      </MobileHeader>
    </Wrapper>
  );
};

export default Header;
